/**
 * CALL IT — the desktop modal (DESIGN-CHANGELOG 2026-09-03 "Adding a game
 * asks for your call"; `design/GT Mine.dc.html:419-437`). AA phase 5.
 *
 * 460px. Header `CALL IT` + `ON THE LIST — HOW BADLY DO YOU WANT IT?`; the
 * game's name; a four-cell strip — pixel glyph over the mono label, the
 * board's own S/A/B/C; `SKIP — CALL IT LATER` at the foot. A call is offered,
 * never forced. Root-mounted: every `+ ADD TO GAMES TONIGHT?` lands here.
 */

import { useQd } from '../../store/index.ts';
import { callItVM } from '../../store/selectors.ts';
import { Modal } from '../components/Modal.tsx';

const MONO = 'var(--gt-font-mono)';
const PIXEL = 'var(--gt-font-pixel)';

export default function CallItModal(): JSX.Element {
  const s = useQd();
  const v = callItVM(s);
  return (
    <Modal
      onClose={() => s.closeAsk()}
      width={460}
      label="Call it now modal"
      header={{ title: 'CALL IT', titleClr: 'var(--gt-text)', titleFs: '10px', note: v.strap }}
    >
      <div style={{ padding: '16px 18px 6px', fontFamily: 'var(--gt-font-sans)', fontWeight: 600, fontSize: 16, color: 'var(--gt-text)' }}>{v.n}</div>
      <div style={{ display: 'flex', padding: '8px 18px 14px' }}>
        {v.cells.map((c, i) => (
          <div
            key={c.key}
            onClick={() => void s.askCall(c.l)}
            className="d-hov-acc-bd"
            style={{
              flex: 1,
              height: 78,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 7,
              border: '1px solid ' + c.clr,
              color: c.clr,
              marginLeft: i ? -1 : 0,
              cursor: 'pointer',
              boxSizing: 'border-box',
            }}
          >
            <span style={{ fontFamily: PIXEL, fontSize: 14, transform: 'translateY(0.13em)' }}>{c.g}</span>
            <span style={{ fontFamily: MONO, fontSize: 8, letterSpacing: '.07em', textAlign: 'center', padding: '0 4px' }}>{c.t}</span>
          </div>
        ))}
      </div>
      <div style={{ padding: '10px 18px 14px', borderTop: '1px solid var(--gt-line)', background: 'var(--gt-raised)' }}>
        <span onClick={() => s.closeAsk()} className="d-hov-acc" style={{ fontFamily: MONO, fontSize: 9.5, letterSpacing: '.07em', color: 'var(--gt-text-5)', cursor: 'pointer' }}>
          {v.skipL}
        </span>
      </div>
    </Modal>
  );
}
